import { useState } from 'react';
import './Contact.css';

// Web3Forms access key — safe to expose in the frontend (public by design).
// Get yours at https://web3forms.com by entering info@ruxiagold.com as the recipient.
const WEB3FORMS_ACCESS_KEY = 'ff3057cf-502c-442f-8aa9-b471edf69ce4';

type Status = 'idle' | 'sending' | 'ok' | 'error';

export function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '', botcheck: '' });
  const [status, setStatus] = useState<Status>('idle');

  const handle = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `Nieuwe aanvraag via ruxiagold.com — ${form.name}`,
          from_name: 'Ruxia Gold website',
          name: form.name,
          email: form.email,
          phone: form.phone,
          message: form.message,
          botcheck: form.botcheck, // honeypot — empty for real users
        }),
      });
      const data = await res.json();
      setStatus(data.success ? 'ok' : 'error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__container">
        <h2 className="contact__title">Neem Contact Op</h2>
        <div className="contact__grid">
          <div className="contact__info">
            <h3 className="contact__info-title">Contactgegevens</h3>
            <div className="contact__info-item">
              <span className="contact__info-icon">✉️</span>
              <a href="mailto:info@ruxiagold.com">info@ruxiagold.com</a>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-icon">📞</span>
              <a href="tel:+3250321788">050/32.17.88</a>
            </div>
            <div className="contact__info-item">
              <span className="contact__info-icon">📍</span>
              <span>Filips de Goedelaan 17, 8000 Brugge</span>
            </div>
            <div className="contact__hours">
              <h4>Openingsuren</h4>
              <ul className="contact__hours-list">
                <li><span className="contact__day">Maandag</span><span>Gesloten</span></li>
                <li><span className="contact__day">Dinsdag</span><span>10:00–12:00, 14:00–18:00</span></li>
                <li><span className="contact__day">Woensdag</span><span>10:00–13:00</span></li>
                <li><span className="contact__day">Donderdag</span><span>10:00–12:00, 14:00–18:00</span></li>
                <li><span className="contact__day">Vrijdag</span><span>10:00–12:00, 14:00–18:00</span></li>
                <li><span className="contact__day">Zaterdag</span><span>10:00–13:00</span></li>
                <li><span className="contact__day">Zondag</span><span>Gesloten</span></li>
              </ul>
            </div>
          </div>

          <form className="contact__form" onSubmit={submit}>
            {status === 'ok' ? (
              <div className="contact__success">
                <span className="contact__success-icon">✓</span>
                <p>Bedankt! Uw bericht is verzonden. Wij nemen zo spoedig mogelijk contact met u op.</p>
              </div>
            ) : (
              <>
                <input
                  name="name" type="text" placeholder="Uw naam" required
                  value={form.name} onChange={handle} className="contact__input"
                  disabled={status === 'sending'}
                />
                <input
                  name="email" type="email" placeholder="Uw e-mailadres" required
                  value={form.email} onChange={handle} className="contact__input"
                  disabled={status === 'sending'}
                />
                <input
                  name="phone" type="tel" placeholder="Uw telefoonnummer (optioneel)"
                  value={form.phone} onChange={handle} className="contact__input"
                  disabled={status === 'sending'}
                />
                <textarea
                  name="message" placeholder="Wat wil u verkopen? (bijv. type metaal, gewicht, hoeveelheid)" required
                  rows={5} value={form.message} onChange={handle}
                  className="contact__input contact__textarea"
                  disabled={status === 'sending'}
                />
                {/* Honeypot: hidden from real users, catches bots (Web3Forms botcheck) */}
                <input
                  name="botcheck" value={form.botcheck} onChange={handle}
                  tabIndex={-1} autoComplete="off" aria-hidden="true"
                  className="contact__hp"
                />
                {status === 'error' && (
                  <p className="contact__error" role="alert">
                    Er ging iets mis bij het verzenden. Probeer het later opnieuw of mail rechtstreeks naar{' '}
                    <a href="mailto:info@ruxiagold.com">info@ruxiagold.com</a>.
                  </p>
                )}
                <button type="submit" className="btn btn--primary" disabled={status === 'sending'}>
                  {status === 'sending' ? 'Versturen…' : 'Verstuur Bericht'}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
